import { render, staticRenderFns } from "./SingleClientView.vue?vue&type=template&id=5d394bb6&"
import script from "./SingleClientView.vue?vue&type=script&lang=js&"
export * from "./SingleClientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports